import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import styles from './SlideCard.module.scss';

function SlideCard(props) {
  const { children, title, right, toggle, actionButton } = props;

  const [active, setActive] = useState(props.active);

  const handleClick = () => {
    if (toggle) {
      setActive(!active);
    }
  };

  const opened = !toggle || active;
  const hasChildren = !!children;

  return (
    <div className={styles.container} data-testid={props.testId || `slidecard-${title}`}>
      <div className={cn(styles.wrapper, toggle ? styles.toggle : '', active ? styles.active : styles.inactive)}>
        <div className={styles.top}>
          <div className={styles.left} onClick={handleClick}>
            <h4>
              {title} {actionButton}
            </h4>
            <span>{props.description}</span>
          </div>

          {right ? (
            <div className={styles.right}>
              {right}

              <span className={cn(styles.arrow, active ? '' : styles.inactive)} onClick={handleClick}>
                <i className="ic-arrow_upward" />
              </span>
            </div>
          ) : null}
        </div>

        {hasChildren && opened ? (
          <div className={styles.body}>
            <hr />
            <div className={styles.content}>{children}</div>
          </div>
        ) : null}
      </div>
    </div>
  );
}

export default SlideCard;

SlideCard.defaultProps = {
  children: null,
  right: null,
  description: '',
  active: true,
  toggle: false,
};

SlideCard.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  description: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
  right: PropTypes.oneOfType([PropTypes.element, PropTypes.bool]),
  active: PropTypes.bool,
  toggle: PropTypes.bool,
};
